/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_EmptyInputs */

const cs_pipelines_empty = /** @type {(inputs: Pipelines_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné pipeline.`)
};

const en_pipelines_empty = /** @type {(inputs: Pipelines_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pipelines.`)
};

/**
* | output |
* | --- |
* | "No pipelines." |
*
* @param {Pipelines_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_empty = /** @type {((inputs?: Pipelines_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_empty(inputs)
	return cs_pipelines_empty(inputs)
});